import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Axios instance สำหรับ Merchant
export const merchantApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true  // ✅ ส่ง cookies ไปกับทุก request
});

// ✅ ไม่ต้องเพิ่ม Authorization header อีกต่อไป - ใช้ cookies แทน
// Cookies จะถูกส่งอัตโนมัติด้วย withCredentials: true
merchantApi.interceptors.request.use(
  (config) => {
    // ไม่ต้องทำอะไร - cookies ส่งอัตโนมัติ
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ⭐ Flag เพื่อป้องกัน alert ซ้ำ
let isRedirectingToLogin = false;

// Interceptor สำหรับเช็ค session expired / token expired
merchantApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response?.data;
    if (data?.session_expired || data?.token_expired) {
      if (process.env.NODE_ENV === 'development') {
        console.log('⚠️ Session/Token expired detected in interceptor');
      }

      // ⭐ ป้องกันวนลูป - เช็คว่าอยู่หน้า login หรือหน้า public อยู่แล้วหรือไม่
      const currentPath = window.location.pathname;
      if (
        currentPath === '/login' ||
        currentPath === '/admin/login' ||
        currentPath === '/reseller/login' ||
        currentPath.startsWith('/agent') || // agent portal มี auth ของตัวเอง
        currentPath.startsWith('/pay/') ||  // หน้า public - ห้าม redirect
        currentPath === '/webhook-test' ||
        currentPath === '/docs'
      ) {
        return Promise.reject(error);
      }

      // ⭐ ป้องกัน redirect ซ้ำ
      if (isRedirectingToLogin) {
        return Promise.reject(error);
      }

      isRedirectingToLogin = true;

      // เลือกหน้า login ตาม portal ที่กำลังใช้งาน
      let loginPath = '/login';
      if (currentPath.startsWith('/admin')) loginPath = '/admin/login';
      else if (currentPath.startsWith('/reseller')) loginPath = '/reseller/login';

      // ✅ ไม่ต้อง clear localStorage - cookies จะหมดอายุอัตโนมัติ
      if (data.session_expired) {
        alert('⚠️ มีการ login จากอุปกรณ์อื่น คุณถูก logout อัตโนมัติ');
      } else {
        alert('⚠️ เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่');
      }

      // ⭐ ใช้ replace แทน href เพื่อไม่ให้กลับหน้าได้
      window.location.replace(
        data.session_expired
          ? `${loginPath}?session_expired=true`
          : `${loginPath}?token_expired=true`
      );
    }
    return Promise.reject(error);
  }
);

// Axios instance สำหรับ External API (ใช้ API Key + Secret)
// ใช้เฉพาะตอนเรียกจากภายนอก เช่น Postman
export const apiV1 = axios.create({
  baseURL: `${API_BASE_URL}/v1`,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor สำหรับเพิ่ม API Keys
apiV1.interceptors.request.use(
  (config) => {
    const apiKey = localStorage.getItem('api_key');
    const apiSecret = localStorage.getItem('api_secret');
    
    if (apiKey && apiSecret) {
      config.headers['X-API-Key'] = apiKey;
      config.headers['X-API-Secret'] = apiSecret;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ⚠️ หมายเหตุ:
// - merchantApi (JWT) → ใช้ใน Frontend ที่ login แล้ว
// - apiV1 (API Key) → ใช้เรียกจากภายนอก (Postman, ระบบอื่น)

export default merchantApi;

